import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';

import { Logger } from '../logger/logger.service';

export interface FcmDevice {
    id: number;
    name: string | null;
    type: 'android' | 'ios' | 'web';
    active: boolean;
    dateCreated: moment.Moment;
}

interface FcmDeviceApiResponse {
    id: number;
    name: string | null;
    type: 'android' | 'ios' | 'web';
    active: boolean;
    dateCreated: string;
}

const LOGGER = new Logger('FcmDeviceService');

@Injectable({
    providedIn: 'root'
})
export class FcmDeviceService {
    private _httpClient = inject(HttpClient);

    /**
     * Retourne la liste des appareils FCM enregistrés pour l'utilisateur courant.
     */
    list$(): Observable<FcmDevice[]> {
        return this._httpClient.get<FcmDeviceApiResponse[]>('/fcm-devices/').pipe(
            map((devices) => devices.map(this._mapDevice))
        );
    }

    /**
     * Enregistre l'appareil courant (le token FCM est envoyé automatiquement
     * via le header X-Device-Token dans l'intercepteur).
     */
    register$(): Observable<FcmDevice> {
        return this._httpClient.post<{ value: FcmDeviceApiResponse }>('/fcm-devices/', {}).pipe(
            map((response) => this._mapDevice(response.value))
        );
    }

    /**
     * Supprime un appareil FCM enregistré.
     */
    delete$(id: number): Observable<void> {
        return this._httpClient.delete<void>(`/fcm-devices/${id}/`);
    }

    private _mapDevice(device: FcmDeviceApiResponse): FcmDevice {
        return {
            id: device.id,
            name: device.name,
            type: device.type,
            active: device.active,
            dateCreated: moment(device.dateCreated),
        };
    }
}
